<template>
    <div>
        <h4>Details:</h4>
        <span v-if="row.FilledQuantity">FilledQuantity:{{row.FilledQuantity}}</span>,
        <span>Underlying:</span>{{row.UnderlyingSymbol}}

        <span v-if="Leg0Description">Leg 0:{{Leg0Description}}</span>
        <span v-if="Leg1Description.length>0">Leg 1:{{Leg1Description}}</span>
    </div>

</template>

<script >
    import {OrderClassMap, OrderDurationMap, OrderStatusMap, OrderTypeMap, OrderSideMap, PositionEffectMap} from "../../domain/TbMaps";

    export default {
        props:['row'],
        computed:{
            Leg0Description:  {
                get(){
                    if (!this.row.Legs || !this.row.Legs[0]) return "";
                    return this.row.Legs[0].Symbol + " " + OrderSideMap[this.row.Legs[0].Action] +" "+ PositionEffectMap[this.row.Legs[0].PositionEffect];}
            },
            Leg1Description:  {
                get(){
                    if (!this.row.Legs || !this.row.Legs[1]) return "";
                    return this.row.Legs[1].Symbol + " " + OrderSideMap[this.row.Legs[1].Action] +" "+ PositionEffectMap[this.row.Legs[1].PositionEffect];}
            },
        },
    };

</script>

